// extracted by mini-css-extract-plugin
export default {"wrap":"VacancyCard_wrap__xhR4j","col":"VacancyCard_col__4T3Qb"};